import { t } from "i18next";

const isRTL = () => {
  const lang =
    localStorage.getItem("SiteLanguage") ||
    document.documentElement.lang ||
    "en";
  return lang === "fa" || lang === "ar";
};

const LoadingIndicator = () => {
  const rtl = isRTL();

  return (
    <div
      className={`fixed bottom-6 z-[2147483000] ${rtl ? "left-8" : "right-8"}`}
    >
      <div className="relative w-24 h-24 flex items-center justify-center">
        <svg
          viewBox="0 0 200 200"
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="100"
            cy="100"
            r="90"
            stroke="var(--purple)"
            strokeOpacity="0.1"
            strokeWidth="2"
            fill="none"
          />
          <circle
            cx="100"
            cy="100"
            r="70"
            stroke="url(#loader_gradient_z)"
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray="300 140"
            fill="none"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 100 100"
              to="360 100 100"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </circle>
          <text
            x="100"
            y="105"
            textAnchor="middle"
            fill="var(--purple)"
            className="text-[16px] font-bol)d font-sans tracking-tight"
            style={{ direction: rtl ? "rtl" : "ltr" }}
          >
            {t("OneMoment")}
            <animate
              attributeName="opacity"
              values="0.4;1;0.4"
              dur="2s"
              repeatCount="indefinite"
            />
          </text>
          <defs>
            <linearGradient
              id="loader_gradient_z"
              x1="30"
              y1="30"
              x2="170"
              y2="170"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="var(--purple)" />
              <stop offset="1" stopColor="var(--purple)" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default LoadingIndicator;
